import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap";

const mockContractsData = [
  {
    id: 1,
    subject: "Website Development",
    customer: "Acme Inc.",
    contractType: "Fixed Price",
    contractValue: 10000,
    startDate: "2024-08-01",
    endDate: "2024-10-31",
    project: "Acme Website Redesign",
    signature: "John Doe (Acme Inc.)",
  },
  {
    id: 2,
    subject: "Marketing Campaign",
    customer: "BigCo Industries",
    contractType: "Hourly",
    contractValue: 50,
    startDate: "2024-07-15",
    endDate: "2024-09-30",
    project: "Brand Awareness Campaign",
    signature: "Jane Smith (BigCo Industries)",
  },
];

function Contracts() {
  const navigate = useNavigate();

  const today = new Date();
  const oneWeekAgo = new Date(today);
  oneWeekAgo.setDate(today.getDate() - 7);
  const aboutToExpireThreshold = 30;        

  const activeContracts = mockContractsData.filter(
    (contract) => !contract.endDate || new Date(contract.endDate) > today
  );
  const expiredContracts = mockContractsData.filter(
    (contract) => contract.endDate && new Date(contract.endDate) < today
  );
  const aboutToExpireContracts = mockContractsData.filter(
    (contract) =>
      contract.endDate &&
      new Date(contract.endDate) - today <=
        aboutToExpireThreshold * 24 * 60 * 60 * 1000
  );
  const recentlyAddedContracts = mockContractsData.filter(
    (contract) => new Date(contract.createdAt) > oneWeekAgo
  );
  const trashContracts = mockContractsData.filter(
    (contract) => contract.deletedAt
  );

  return (
    <>
      <div className="page-content">
        <Container fluid={true} className="py-4">
          <Row>
            <Row className="d-flex justify-content-between align-items-center">
              <Col xs="auto">
                <Button
                  color="primary"
                  outline
                  className="waves-effect waves-light"
                  onClick={() => navigate("/contracts/add-contract")}
                >
                  Add Contract
                </Button>
              </Col>
              <Col xs="auto" className="d-flex gap-3">
                <div>
                  <span className="text-success">Active Contracts:</span>{" "}
                  {activeContracts.length}
                </div>
                <div>
                  <span className="text-danger">Expired Contracts:</span>{" "}
                  {expiredContracts.length}
                </div>
                <div>
                  <span className="text-warning">About to Expire:</span>{" "}
                  {aboutToExpireContracts.length}
                </div>
                <div>
                  <span className="text-primary">Recently Added:</span>{" "}
                  {recentlyAddedContracts.length}
                </div>
                <div>
                  <span className="text-muted">Trash:</span>{" "}
                  {trashContracts.length}
                </div>
              </Col>
            </Row>
            <Row className="py-3">
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <CardTitle className="h4">Contracts</CardTitle>
                    <div className="table-responsive">
                      <Table className="table mb-0">
                        <thead>
                          <tr>
                            <th>Subject</th>
                            <th>Customer</th>
                            <th>Contract Type</th>
                            <th>Contract Value</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Project</th>
                            <th>Signature</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {mockContractsData.map((contract, index) => (
                            <tr key={index}>
                              <td>{contract.subject}</td>
                              <td>{contract.customer}</td>
                              <td>{contract.contractType}</td>
                              <td>{contract.contractValue}</td>
                              <td>{contract.startDate}</td>
                              <td>{contract.endDate}</td>
                              <td>{contract.project}</td>
                              <td>{contract.signature}</td>
                              <td>
                                <div className="d-flex gap-3 align-items-center">
                                  <i className="ti-pencil action-icon"></i>
                                  <i className="ti-trash action-icon"></i>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Contracts;
